import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import Tax from "./tax/Tax";
import Homepage from "./homepage/Homepage";
import * as PropTypes from "prop-types";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Homepage />,
    },
    {
        path: "/tax/:id",
        element: <Tax />
    }
]);
const root = ReactDOM.createRoot(document.getElementById('root'));

function HelmetProvider(props) {
    return null;
}

HelmetProvider.propTypes = {children: PropTypes.node};
root.render(
  <React.StrictMode>
      <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
